<template>
  <div>

      
    </div>
</template>

<script>


export default {
  name: 'Comunication',
 
  data () {
    return {
    }
  },
  computed: {
    selectedLocation (){
      return this.$store.getters['locations/getSelectedLocation'];
    },
  },
  methods: {
  },
  watch: {
  },
  created() {
    this.$store.commit('setTitle', 'Materiales de apoyo');
    this.$store.commit('setMenuVisible', false);
  },
  beforeRouteLeave (to, from, next) {
      next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>



</style>